import { FiCornerUpLeft, FiEye, FiGift, FiSend } from "react-icons/fi";
import spacetime from "spacetime";

interface Props {
  type: string;
}

const TYPE_META: Record<
  string,
  { label: string; icon: React.ReactNode }
> = {
  create: {
    label: "Tossed",
    icon: <FiGift className="h-4 w-4" />,
  },
  open: {
    label: "Unwrapped",
    icon: <FiEye className="h-4 w-4" />,
  },
  send: {
    label: "Banana forwarded",
    icon: <FiSend className="h-4 w-4" />,
  },
  sendBack: {
    label: "Banana backed",
    icon: <FiCornerUpLeft className="h-4 w-4" />,
  },
};

export const BananaTypeLabel = ({ type }: Props) => {

  const meta = TYPE_META[type] ?? TYPE_META.create;

  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-medium tracking-tight select-none`}>
      {meta.icon}
      {meta.label}
    </span>
  )
}